module.exports = __webpack_public_path__ + "static/AzoSans-Bold-8eb0f36a106b7cb0b2eeba0d08bb9502.woff";